<div class="CollapsibleFeaturesList">

    <Collapsible v-for="entry in featuresList.entries" :title="entry.layer.get('title')" class="CollapsibleFeaturesList__LayerHeading">

        <Collapsible v-for="(feature,index) in getFeaturesOrdered(entry)" :title="getFeatureLabel(feature, entry.layer, 'Objekt ' + (index+1))" :collapsed="featuresList.numFeatures() != 1" :exclusive="true">
            <PropertyGridWithSlideshow :value="feature.getProperties()" :fieldsConfig="entry.layer.get('propertyLabels')" :fieldsBlacklist="['geometry']" />
        </Collapsible>

    </Collapsible>

</div>